import React, { useState, useEffect } from 'react';
import englishFlag from '../images/english-flag.jpg';
import irishFlag from '../images/irish-flag.png';
import frenchFlag from '../images/french_flag.jpg';
import spanishFlag from '../images/spanish_flag.jpg';
import germanFlag from '../images/german_flag.jpg';
import mathFlag from '../images/math-flag.jpg';
import biologyFlag from '../images/bio-flag.jpg'; // Reusing math flag temporarily for biology
import chemistryFlag from '../images/chem-flag.jpg'; // Reusing math flag temporarily for chemistry
import customFlag from '../images/custom-flag.jpg';
import logger from '../utils/logger';
import '../styles/CategorySelection.scss';

// Keep getCategoryIcon outside since it doesn't need component state
export const getCategoryIcon = (category) => {
  const icons = {
    'Shakespeare': '🎭',
    'GCSE_Shakespeare': '🎭',
    'GCSE_19th': '📚',
    'GCSE_Inspector': '🕵️‍♂️',
    'GCSE_Poetry': '📜',
    'Comparative': '⚖️',
    'Composition': '✍️',
    'Comprehension': '📖',
    'IE_Oral': '🎤',
    'Grammar Checker': '📝',
    'Filiocht': '📖',
    'FR_Diary': '📔',
    'FR_Opinion': '💭',
    'FR_Email': '📧',
    'FR_Recit': '📝',
    'FR_Oral': '🎤',
    'ES_Opinion': '💬',
    'ES_LetterEmail': '✉️',
    'ES_Diary': '📓',
    'ES_Note': '📝',
    'ES_Oral': '🎤',
    'DE_Ausserung': '💬',
    'DE_Letter': '✉️',
    'DE_TopicalQuestions': '❓',
    'DE_Oral': '🎤',
    'FR_Grammar': '📝',
    'ES_Grammar': '📝',
    'DE_Grammar': '📝',
    'MATH_Concepts': '🧮',
    'MATH_Applications': '📊',
    'GCSE_French_Q1': '🇫🇷1️⃣',
    'GCSE_French_Q2': '🇫🇷2️⃣',
    'GCSE_Spanish_Q1': '🇪🇸1️⃣',
    'GCSE_Spanish_Q2': '🇪🇸2️⃣',
    'GCSE_German_Q1': '🇩🇪1️⃣',
    'GCSE_German_Q2': '🇩🇪2️⃣',
    'GCSE_FR_Grammar': '📝',
    'GCSE_ES_Grammar': '📝',
    'GCSE_DE_Grammar': '📝',
    'Biology': '🧬',
    'Chemistry': '⚗️',
    'Custom': '📝',
    // New oral categories with microphone icon
  };
  return icons[category] || '📚';
};

export const FILIOCHT_POEMS = {
  "geibh": "Géibheann",
  "tearrach": "An tEarrach Thiar",
  "moghrasa": "Mo ghrá-sa",
  "colscaradh": "Colscaradh",
  "spailpin": "An Spailpín Fánach"
};

export const categories = {
  English: [
    {value: 'GCSE_Shakespeare', display: 'Shakespeare'},
    {value: 'GCSE_19th', display: '19th Century Novel'},
    {value: 'GCSE_Inspector', display: 'Modern Text'},
    {value: 'GCSE_Poetry', display: 'Poetry'},
    'Shakespeare',
    'Poetry',
    'Comparative',
    'Composition',
    {value: 'Comprehension', display: 'Comprehension'}
  ],
  Irish: [
    {value: 'IE_Oral', display: 'Oral Exam'},
    'Aiste',
    {value: 'Grammar Checker', display: 'Grammar & Spelling Checker'},
    {value: 'Filiocht', display: 'Filíocht', subcategories: [
      {value: 'Filiocht_I', display: 'Cuid I'},
      {value: 'Filiocht_II', display: 'Cuid II'},
      {value: 'Filiocht_III', display: 'Cuid III'}
    ]}
  ],
  French: [
    {value: 'FR_Oral', display: 'Oral Exam'},
    {value: 'FR_Diary', display: 'Diary'},
    {value: 'FR_Opinion', display: 'Opinion'},
    {value: 'FR_Email', display: 'Email'},
    {value: 'FR_Recit', display: 'Récit'},
    {value: 'FR_Grammar', display: 'Grammar & Spelling Checker'}
  ],
  French_GCSE: [
    {value: 'GCSE_French_Q1', display: 'Question 1'},
    {value: 'GCSE_French_Q2', display: 'Question 2'},
    {value: 'GCSE_FR_Grammar', display: 'Grammar & Spelling Checker'}
  ],
  Spanish: [
    { value: 'ES_Oral',        display: 'Oral Exam'    },
    { value: 'ES_Opinion',     display: 'Opinion'      },
    { value: 'ES_LetterEmail', display: 'Letter/Email' },
    { value: 'ES_Diary',       display: 'Diary'        },
    { value: 'ES_Note',        display: 'Note'         },
    { value: 'ES_Grammar',     display: 'Grammar & Spelling Checker' }
  ],
  Spanish_GCSE: [
    {value: 'GCSE_Spanish_Q1', display: 'Question 1'},
    {value: 'GCSE_Spanish_Q2', display: 'Question 2'},
    {value: 'GCSE_ES_Grammar', display: 'Grammar & Spelling Checker'}
  ],
  German: [
    { value: 'DE_Oral',             display: 'Oral Exam' },
    { value: 'DE_Ausserung',        display: 'Äußerung' },
    { value: 'DE_Letter',           display: 'Letter' },
    { value: 'DE_TopicalQuestions', display: 'Topical Questions' },
    { value: 'DE_Grammar',          display: 'Grammar & Spelling Checker' }
  ],
  German_GCSE: [
    {value: 'GCSE_German_Q1', display: 'Question 1'},
    {value: 'GCSE_German_Q2', display: 'Question 2'},
    {value: 'GCSE_DE_Grammar', display: 'Grammar & Spelling Checker'}
  ],
  Maths: [
    { value: 'MATH_Concepts', display: 'Concepts and Skills' },
    { value: 'MATH_Applications', display: 'Contexts and Applications' }
  ],
  Biology: [
    {value: 'Quiz', display: 'Quiz'}
  ],
  Chemistry: [
    {value: 'Quiz', display: 'Quiz'}
  ],
  'Revise Anything!': [
    {value: 'Custom', display: 'Revise Anything!'}
  ]
};

function CategorySelection({
  selectedBranch,
  setSelectedBranch,
  selectedFiliocht,
  setSelectedFiliocht,
  selectedPoem,
  setSelectedPoem,
  setCategory,
  setQuestion,
  setStep,
  usageRemaining,
  userCountry,
  userData
}) {
  // Add debugging to see what country is being passed
  logger.debug('CategorySelection - userCountry:', userCountry);
  
  // Check if user is an admin (like in Sidebar.js)
  const isAdmin = userData && (userData.username === "charles" || userData.username === "cillian");
  
  // Get available language branches based on user's country and admin status
  const getAvailableLanguages = () => {
    // Get the base languages based on country
    const baseLanguages = getBaseLanguagesByCountry();
    
    // Return filtered languages, mapping language keys for UK users if needed
    return baseLanguages; // Return the languages directly, mapping is done in getBaseLanguagesByCountry
  };
  
  // Helper function to get base languages by country
  const getBaseLanguagesByCountry = () => {
    // If no country set, assume Ireland (show all languages)
    if (!userCountry) {
      logger.info('No userCountry - assuming Ireland - showing all languages');
      const allLanguages = Object.keys(categories).filter(lang => !lang.endsWith('_GCSE'));
      // Move 'Revise Anything!' to the front
      return ['Revise Anything!', ...allLanguages.filter(lang => lang !== 'Revise Anything!')];
    }
    
    const countryLower = userCountry.toLowerCase();
    logger.debug('Country (lowercase):', countryLower);
    
    // More robust check for UK users (handle different formats)
    if (countryLower === 'united kingdom' || 
        countryLower === 'uk' || 
        countryLower === 'great britain' || 
        countryLower === 'britain') {
      logger.info('UK user detected - returning UK-specific languages');
      // Explicitly return the keys relevant for UK users, including Revise Anything!
      return ['Revise Anything!', 'English', 'Maths', 'French_GCSE', 'Spanish_GCSE', 'German_GCSE'];
    }
    
    // For Irish users (and default), show all languages except GCSE
    logger.info('Non-UK user - showing all languages except GCSE');
    const allLanguages = Object.keys(categories).filter(lang => !lang.endsWith('_GCSE'));
    // Move 'Revise Anything!' to the front
    return ['Revise Anything!', ...allLanguages.filter(lang => lang !== 'Revise Anything!')];
  };

  // Helper to check if the user is from the UK
  const checkIsUKUser = () => {
    const countryLower = userCountry ? userCountry.toLowerCase() : 'ireland'; // Treat missing as non-UK
    return countryLower === 'united kingdom' || 
           countryLower === 'uk' || 
           countryLower === 'great britain' || 
           countryLower === 'britain';
  }

  // Filter categories based on user's country and mapped language key
  const getFilteredCategories = (language) => {
    const isUKUser = checkIsUKUser();
    // Determine the correct key to access categories based on user country
    let categoryKey = language; // Default to the passed language (e.g., 'English', 'Maths', 'French')
    if (isUKUser) {
      if (language === 'French') categoryKey = 'French_GCSE';
      else if (language === 'Spanish') categoryKey = 'Spanish_GCSE';
      else if (language === 'German') categoryKey = 'German_GCSE';
      // 'English' and 'Maths' use the original key
    }

    const languageCategories = categories[categoryKey];
    if (!languageCategories) {
      logger.error(`No categories found for language key: ${categoryKey}`);
      return []; // Return empty array if categories not found
    }
    
    // Filter logic based on UK user status and original language
    if (isUKUser) {
      if (language === 'English') {
        // For UK users, only show GCSE categories in the English Literature section
        return languageCategories.filter(category => {
          const value = typeof category === 'string' ? category : category.value;
          return value === 'GCSE_Shakespeare' || value === 'GCSE_19th' || value === 'GCSE_Inspector' || value === 'GCSE_Poetry';
        });
      } else if (language === 'Maths') {
        // For UK users, only show MATH_Concepts in the Maths section
        return languageCategories.filter(category => {
          const value = typeof category === 'string' ? category : category.value;
          return value === 'MATH_Concepts';
        });
      } else if (language !== 'Irish') {
        // For UK users, non-English/Irish languages use the _GCSE specific categories
        // The filtering is implicitly done by fetching categories[mappedLanguage]
        return languageCategories;
      }
    } else {
      // For non-UK users (including missing country), filter out GCSE categories
      // We still need to filter *within* the language category array for non-UK users
      return languageCategories.filter(category => {
        const value = typeof category === 'string' ? category : category.value;
        return typeof value === 'string' && !value.startsWith('GCSE_');
      });
    }
    
    // Default return (should ideally not be reached if logic above is exhaustive)
    return languageCategories;
  };

  const availableLanguages = getAvailableLanguages();
  logger.debug('Available languages:', availableLanguages);

  const handleCategorySelect = (selectedCategory) => {
    if (selectedCategory === 'Filiocht') {
      setSelectedFiliocht(true);
      setSelectedPoem(null);  // Reset poem selection
      return;
    }
    
    // Reset Filiocht state for all other categories
    setSelectedFiliocht(false);
    setSelectedPoem(null);
    
    // Special handling for Comprehension - just set category, don't change step yet
    if (selectedCategory === 'Comprehension') {
      setCategory(selectedCategory);
      // Let MainContent handle rendering ComprehensionView in Step 1
      return; 
    }
    
    // Special handling for Quiz in Biology or Chemistry categories
    if (selectedCategory === 'Quiz' && (selectedBranch === 'Biology' || selectedBranch === 'Chemistry')) {
      setCategory(selectedBranch);
      // Let MainContent handle rendering QuizWorkflow in Step 1
      return;
    }
    
    if (selectedCategory === 'Grammar Checker' || selectedCategory === 'FR_Grammar' || 
        selectedCategory === 'ES_Grammar' || selectedCategory === 'DE_Grammar' ||
        selectedCategory === 'GCSE_FR_Grammar' || selectedCategory === 'GCSE_ES_Grammar' || 
        selectedCategory === 'GCSE_DE_Grammar') {
      setCategory(selectedCategory);
      setQuestion("Grammar Check");
      setStep(3);
    } else {
      setCategory(selectedCategory);
      setStep(2);
    }
  };

  const handleFiliochtPartSelect = (part) => {
    if (!selectedPoem) return;  // Don't proceed without poem selection
    setCategory(part);
    // Don't set any initial question text
    setStep(2);
    setSelectedFiliocht(null);
  };

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  
  // Handle responsive layout
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div>
      {!selectedBranch ? (
        <>
          <div className="language-selection">
            {availableLanguages.map((branch) => {
              // For UK users, display "English Literature" instead of "English"
              const isUKUser = checkIsUKUser();
              let displayName = branch.endsWith('_GCSE') ? branch.replace('_GCSE', '') : branch; // Basic name
              if (isUKUser && branch === 'English') {
                displayName = 'English Literature';
              }
              // Correct the branch name used for selection if it's a GCSE branch
              const selectionBranchName = branch.endsWith('_GCSE') ? branch.replace('_GCSE', '') : branch;

              return (
                <button
                  key={branch}
                  className="language-button"
                  onClick={() => {
                    // Check if UK user selecting Maths - skip category selection
                    if (isUKUser && selectionBranchName === 'Maths') {
                      // UK users selecting Maths - go directly to next step
                      setCategory('MATH_Concepts');
                      setStep(2);
                    } else if (selectionBranchName === 'Biology' || selectionBranchName === 'Chemistry') {
                      // For Biology/Chemistry, set category to the subject name and go to step 1
                      // This allows MainContent to pick up and render the QuizWorkflow
                      setSelectedBranch(selectionBranchName); // Set the selected branch for context
                      setCategory(selectionBranchName);     // Set category to 'Biology' or 'Chemistry'
                      setStep(1);                         // Explicitly go to step 1 for quiz workflow
                    } else if (selectionBranchName === 'Revise Anything!') {
                      // For Revise Anything!, set category to 'Custom' and go to step 1
                      // This will trigger the StudentNotesWorkflow
                      setSelectedBranch(selectionBranchName);
                      setCategory('Custom');
                      setStep(1);
                    } else {
                      // Normal flow - go to category selection
                      setSelectedBranch(selectionBranchName); // Set the display branch name
                    }
                  }}
                >
                  <img
                    src={selectionBranchName === 'English' ? englishFlag :
                        selectionBranchName === 'Irish' ? irishFlag :
                        selectionBranchName === 'French' ? frenchFlag :
                        selectionBranchName === 'Spanish' ? spanishFlag :
                        selectionBranchName === 'German' ? germanFlag :
                        selectionBranchName === 'Maths' ? mathFlag :
                        selectionBranchName === 'Biology' ? biologyFlag :
                        selectionBranchName === 'Chemistry' ? chemistryFlag :
                        selectionBranchName === 'Revise Anything!' ? customFlag :
                        englishFlag} // Default/fallback flag
                    alt={`${displayName} flag`}
                    className="language-flag"
                  />
                  <span className="language-name" style={{
                    marginTop: selectionBranchName === 'Revise Anything!' ? '0px' : '0'
                  }}>{displayName}</span>
                </button>
              );
            })}
          </div>
        </>
      ) : (
        <>
          <div className="back-container">
            <button 
              onClick={() => {
                setSelectedBranch(null);
                setSelectedFiliocht(null);  // Reset Filiocht selection when going back
                setSelectedPoem(null);      // Reset poem selection when going back
              }}
              className="back-to-languages"
            >
              ← Back to Subjects
            </button>
            <h2>{checkIsUKUser() && selectedBranch === 'English' ? 'English Literature' : selectedBranch} Categories</h2>
          </div>
          
          {selectedFiliocht ? (
            <div>
              {!selectedPoem ? (
                <>
                  <h3>Roghnaigh dán:</h3>
                  <div className="poem-selection">
                    {Object.entries(FILIOCHT_POEMS).map(([key, title]) => (
                      <button
                        key={key}
                        onClick={() => setSelectedPoem(key)}
                        className={`poem-button poem-${key}`}
                      >
                        {title}
                      </button>
                    ))}
                  </div>
                </>
              ) : (
                <>
                  <h3>{FILIOCHT_POEMS[selectedPoem]}</h3>
                  <div className="poem-selection">
                    {categories.Irish.find(c => c.value === 'Filiocht').subcategories.map((part) => (
                      <button
                        key={part.value}
                        onClick={() => handleFiliochtPartSelect(part.value)}
                        className="filiocht-part-button"
                        data-part={part.value}
                      >
                        <span style={{ fontSize: '1.5em' }}>📝</span>
                        {part.display}
                      </button>
                    ))}
                    <button
                      onClick={() => setSelectedPoem(null)}
                      className="secondary-button"
                    >
                      Roghnaigh dán eile
                    </button>
                  </div>
                </>
              )}
            </div>
          ) : (
            <div className="category-buttons" style={{
              display: 'grid',
              gridTemplateColumns: isMobile ? '1fr' : 'repeat(2, 1fr)',
              gap: isMobile ? '10px' : '16px',
              width: '80%',
              maxWidth: isMobile ? '180px' : '300px',
              margin: '0 auto'
            }}>
              {getFilteredCategories(selectedBranch).map((category) => {
                const value = typeof category === 'string' ? category : category.value;
                // Create CSS class, mapping GCSE categories to appropriate styling
                const cssClass = value === 'Comprehension' // Add condition for Comprehension first
                  ? 'category-button category-comprehension'
                  : value === 'Biology' || value === 'Chemistry'
                  ? `category-button category-${value.toLowerCase()}`
                  : value === 'GCSE_Shakespeare' 
                  ? 'category-button category-shakespeare'
                  : value === 'GCSE_19th'
                    ? 'category-button category-composition' // Reuse the composition styling for 19th Century Novel
                    : value === 'GCSE_Inspector'
                      ? 'category-button category-inspector' // Reuse the inspector styling for Modern Text
                      : value === 'GCSE_Poetry'
                        ? 'category-button category-poetry' // Reuse the poetry styling for Poetry
                        : value.startsWith('GCSE_') && value.endsWith('_Q1') // Style GCSE Q1 like grammar
                        ? 'category-button category-poetry'
                        : value.startsWith('GCSE_') && value.endsWith('_Q2') // Style GCSE Q2 like composition
                        ? 'category-button category-composition'
                        : value.startsWith('GCSE_') && value.endsWith('_Grammar') // Style GCSE Grammar like grammar
                        ? 'category-button category-grammar-checker' // Reuse grammar checker style
                        : value === 'MATH_Concepts' || value === 'MATH_Applications'
                          ? `category-button category-math-${value.split('_')[1].toLowerCase()}`
                          : `category-button category-${value.toLowerCase().replace(/\s+/g, '-')}`;
                
                return (
                  <button
                    key={value}
                    onClick={() => handleCategorySelect(value)}
                    className={cssClass}
                    style={{
                      width: '80%',
                      height: '100px', // Fixed height for all buttons
                      display: 'flex',
                      flexDirection: 'column',
                      justifyContent: 'center',
                      alignItems: 'center',
                      padding: isMobile ? '10px 16px' : '20px',
                      fontSize: isMobile ? '0.95em' : 'inherit',
                      textAlign: 'center'
                    }}
                  >
                    <span className="category-icon" style={{
                      fontSize: isMobile ? '1.5em' : '2em',
                      marginBottom: isMobile ? '5px' : '8px'
                    }}>
                      {getCategoryIcon(value)}
                    </span>
                    <span style={{ 
                      display: 'block',
                      width: '100%',
                      wordBreak: 'break-word',
                      hyphens: 'auto'
                    }}>
                      {(() => {
                        // Special case for UK users and MATH_Concepts
                        const isUKUser = checkIsUKUser();
                        
                        if (isUKUser && value === 'MATH_Concepts') {
                          return "GCSE Maths";
                        }
                        
                        return typeof category === 'string' ? category : category.display;
                      })()}
                    </span>
                  </button>
                );
              })}
            </div>
          )}
        </>
      )}
      
    </div>
  );
}

export default CategorySelection; 